import './ExtendedDataModal.scss';
import Modal from '@mui/material/Modal';
import React from 'react';

import { useTranslation } from 'src/i18n';
import { getClient } from 'src/module/authentication/selector';
import { useSelector } from 'react-redux';
import Button from 'src/component/UI/Button';

import * as json from './deviceMetadata/json';
import * as propUtils from './deviceMetadata/render';


interface ExtendedPropertiesModalProps {
  handleClose: () => void;
  open: boolean;
  properties?: Record<string, string>;
  showUnknown?: boolean;
  markUnknown?: boolean;
}

const defaultProps = {
  handleClose: () => {},
  open: false,
  properties: {},
  showUnknown: false,
  markUnknown: false,
} as const;

export default function ExtendedDataModal ({
  handleClose =  defaultProps.handleClose,
  open = defaultProps.open,
  properties = defaultProps.properties,
  showUnknown = defaultProps.showUnknown,
  markUnknown = defaultProps.markUnknown,
}: ExtendedPropertiesModalProps) {
  const { t } = useTranslation();
  const client = useSelector(getClient);
  const device_metadata_raw = client.getIn(['preferences', 'device', 'metadata'], null);
  const device_metadata = json.jsonToMetadataPreferences(device_metadata_raw ? device_metadata_raw.toJS() : null);
  const renderOrder = propUtils.orderedRenderers(device_metadata);
  const unknownProperties = Object.keys(properties).filter(key => !device_metadata[key]);

  return (
    <Modal
      data-testid='extended-data-modal'
      open={open}
      onClose={handleClose}
      aria-labelledby='extended-data-modal-title'
    >
      <div className='modal extended-data-modal'>
        <h2 id='extended-data-modal-title'>{t('deviceProperties.extendedDeviceData')}</h2>
        <div className="properties-list">
          {renderOrder.map(({ property, renderer }) => (
            <div key={property} className='property-row'>
              <div key={`${property}-label`} className='property label'>{t(`deviceProperties.${property}`)}</div>
              <div key={`${property}-value`} className='property value'>{renderer(properties[property])}</div>
            </div>
          ))}

          {showUnknown && unknownProperties.map(key => {
            const classNames = ['property'];
            if (markUnknown) {
              classNames.push('unknown');
            }
            return (
              <div key={key} className='property-row'>
                <div key={`${key}-label`} className={classNames.join(' ') + ' label'}>{t(`deviceProperties.${key}`)}</div>
                <div key={`${key}-value`} className={classNames.join(' ') + ' value'}>{propUtils.renderDefault(properties[key])}</div>
              </div>
            );
          })}
        </div>

        <div className='button-bar'>
          <Button onClick={handleClose}>{t('common.close')}</Button>
        </div>
      </div>
    </Modal>
  );
}
